import { render, staticRenderFns } from "./serve.vue?vue&type=template&id=5e26a3c5&scoped=true"
import script from "./serve.vue?vue&type=script&lang=js"
export * from "./serve.vue?vue&type=script&lang=js"
import style0 from "./serve.vue?vue&type=style&index=0&id=5e26a3c5&lang=less&scoped=true"
import style1 from "./serve.vue?vue&type=style&index=1&id=5e26a3c5&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e26a3c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e26a3c5')) {
      api.createRecord('5e26a3c5', component.options)
    } else {
      api.reload('5e26a3c5', component.options)
    }
    module.hot.accept("./serve.vue?vue&type=template&id=5e26a3c5&scoped=true", function () {
      api.rerender('5e26a3c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/venue/serve.vue"
export default component.exports